// extracted by mini-css-extract-plugin
var _1 = "UserCard-module__animatedBackground--RF5uU";
var _2 = "UserCard-module__footer--GYd8F";
var _3 = "UserCard-module__noAccess--eHrlj";
export { _1 as "animatedBackground", _2 as "footer", _3 as "noAccess" }
